module.exports = __webpack_public_path__ + "static/media/SummerHitList.b8cab7fc.jpg";